import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  Button,
  Row,
  Col,
  Checkbox,
  Modal,
  Input,
  InputGroup,
  ControlLabel,
  SelectPicker,
  Uploader,
  Message,
  ButtonGroup,
  Popover,
  Whisper,
} from 'rsuite'
import classNames from 'classnames'
import { LOCAL_DAY_TH, DD_MM_YYYY_SLASH, DATE_PICKER_FORMAT } from '../../../constants/date'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  isImageOrPdf,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { startLoading, doneLoading } from '../../../utils/loading'
import {
  getAssetRegisterById,
  saveAssetRegister,
  saveAssetRegisterRequest,
  getAssetRegister,
} from '../../../redux/actions/addDurableArticles'
import {
  downloadDurableArticlesFile,
  downloadAssetRegisterFile,
} from '../../../redux/actions/accountingExpenses'
import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'
import AppContext from '../../../context/AppContext'
import { isEmpty } from 'lodash-es'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import notification from '../../../utils/notification'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import AlertWidget from '../../confirm/AlertWidget'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { v4 as uuidv4 } from 'uuid'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import './styles.less'
import { budgetFormat } from '../../../utils/formatterUtil'
import TagCell from '../../../components/cell/TagCell'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import TooltipButton from '../../../components/buttons/TooltipButton'
import { cloneDeep } from 'lodash-es'
import {
  DEFAULT_ERR_MSG,
  ERR_MSG,
  PROCESS_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
} from '../../../constants/msgText'
import NumberFormat from 'react-number-format'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function AddDurableArticlesTable({
  schema,
  loading,
  isViewMode,
  defaultDisplay = 10,
  defaultPage = 1,
  pagination,
  lengthMenu,
  onViewHistory = () => {},
}) {
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [formSchema, setFormSchema] = useState(schema)
  const [assetRegisSchema, setAssetRegisSchema] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  //const [isError, setIsError] = useState(false)
  const [error, setError] = useState()
  const [isShowReqRegisterModal, setIsShowReqRegisterModal] = useState(false)
  const [isAddDetail, setAddDetail] = useState(false)
  const [isShowQrCodeModal, setIsShowQrCodeModal] = useState(false)
  const [qrCodeDataRow, setQrCodeDataRow] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [myDataRow, setMyDataRow] = useState()
  const [isShowModalHelper, setIsShowModalHelper] = useState(false)
  const [requestRegisterNote, setRequestRegisterNote] = useState()
  const [checked, setChecked] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [assetPicturePathFile, setAssetPicturePathFile] = useState([])
  const [assetBillPathFile, setAssetBillPathFile] = useState([])
  const [assetOtherAttach, setAssetOtherAttach] = useState([])
  const [assetReceivePathFile, setAssetReceivePathFile] = useState([])
  const [deleteAttachFiles, setDeleteAttachFiles] = useState([])
  const [staDeleteAssetPicturePathFile, setStaDeleteAssetPicturePathFile] = useState(false)
  const [staDeleteAssetBillPathFile, setStaDeleteAssetBillPathFile] = useState(false)
  const [staDeleteAssetReceiveFile, setStaDeleteAssetReceiveFile] = useState(false)
  const [periodMainSelection, setPeriodMainSelection] = useState(
    schema?.periodOption?.value || schema?.periodOption?.options[0]?.value
  )
  const [fileName, setFileName] = useState('')
  const [periodOptionValue, setPeriodOptionValue] = useState(
    schema?.periodOption?.value || schema?.periodOption?.options[0]?.value
  )
  const [searchProjectCode, setSearchProjectCode] = useState('')
  const [searchPeriod, setSearchPeriod] = useState('')

  const projectCode = sessionGetItemStr('projectCode')
  const fs = localStorage.getItem('fontSize')
  const defaultMaxFileSize = 5
  const [isSearch, setIsSearch] = useState(false)
  //const [messageInfo, setMessageInfo] = useState()
  const [isSearchLoading, setIsSearchLoading] = useState(false)
  const [projectInfo, setProjectInfo] = useState()
  const [totalSize, setTotalSize] = useState()
  const [displayLength, setDisplayLength] = useState(defaultDisplay)
  const [page, setPage] = useState(defaultPage)

  //const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
  ]

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  useEffect(() => {
    setTotalSize(schema.totalSize || 0)
    handleChangePeriodOption(periodOptionValue)
  }, [schema])

  const handleClickDetailModal = (rowData) => {
    console.log('rowData => ', rowData)
    setMyDataRow(rowData)
    setIsEditMode(rowData.isEnableEdit)
    // setIsEditMode(true)

    setAssetRegisSchema()
    setAssetPicturePathFile([])
    setAssetBillPathFile([])
    setAssetReceivePathFile([])
    setAssetOtherAttach([])
    handleGetAssetRegisterById(rowData.id)
    setAddDetail(true)
  }

  const handleGetAssetRegisterById = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetRegisterById(id)
      console.log('handleGetAssetRegisterById ** ', _schema.model)

      if (_schema.model.picturePathFile) {
        let newArr = []
        let filed = _schema.model.picturePathFile.split('/')

        newArr.push({ label: filed[3] || 'ภาพครุภัณฑ์', path: _schema.model.picturePathFile })
        setAssetPicturePathFile(newArr)
      }
      // console.log('_schema.model.assetPicturePathFile ', _schema.model.assetPicturePathFile)

      if (_schema.model.billPathFile) {
        let newArr1 = []
        let filed = _schema.model.billPathFile.split('/')

        newArr1.push({
          label: filed[3] || 'ใบเสร็จครุภัณฑ์',
          path: _schema.model.billPathFile,
        })
        setAssetBillPathFile(newArr1)
      }

      if (_schema.model.receivePathFile) {
        let newArr2 = []
        let filed = _schema.model.receivePathFile.split('/')

        newArr2.push({
          label: filed[3] || 'เอกสารตรวจนับ',
          path: _schema.model.receivePathFile,
        })

        setAssetReceivePathFile(newArr2)
      }

      if (_schema.model.assetOtherAttach) {
        setAssetOtherAttach(_schema?.model?.assetOtherAttach?.values || [])
      }
      // console.log('gggg jjj ', _schema.model)
      setAssetRegisSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async (data) => {
    console.log('onSubmit ', data)
    // return false
    const formData = new FormData()

    formData.append('Id', myDataRow.id)
    formData.append('AssetName', data.AssetName || '')
    formData.append('Price', data.price || 0)
    formData.append('AssetSerialNo', data.assetSerialNo || '')
    formData.append('AssetModel', data.assetModel || '')
    formData.append('AssetBrand', data.assetBrand || '')
    formData.append('AssetType', data.assetType || '')
    formData.append('AssetBillNo', data.assetBillNo || '')
    formData.append('AssetBillDate', moment(data.assetBillDate).format('YYYY/MM/DD') || '')
    formData.append('Status', data.status || '')
    formData.append('AssetReceiveDate', moment(data.assetReceiveDate).format('YYYY/MM/DD') || '')

    data.assetBillPathFile &&
      data.assetBillPathFile?.forEach((element) => {
        formData.append('AssetBillFile', element.blobFile)
      })
    formData.append('IsDeleteAssetBillPathFile', staDeleteAssetBillPathFile)

    data.assetPicturePathFile &&
      data.assetPicturePathFile?.forEach((element) => {
        formData.append('AssetPictureFile', element.blobFile)
      })
    formData.append('IsDeleteAssetPicturePathFile', staDeleteAssetPicturePathFile)

    data.assetOtherAttach &&
      data.assetOtherAttach?.forEach((element) => {
        formData.append('AssetOtherAttachs', element.blobFile)
      })

    deleteAttachFiles.length > 0 &&
      deleteAttachFiles?.forEach((element) => {
        formData.append('DeleteFileIds', element.id)
      })

    data.assetReceiveFile &&
      data.assetReceiveFile?.forEach((element) => {
        formData.append('AssetReceiveFile', element.blobFile)
      })
    formData.append('IsDeleteAssetReceivePathFile', staDeleteAssetReceiveFile)

    // IsDeleteAssetBillPathFile
    // IsDeleteAssetPicturePathFile
    handleSaveDurableAriticles(formData)
  }

  const handleSaveDurableAriticles = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await saveAssetRegister(request, projectCode, periodMainSelection)

      if (response) {
        setTableData(response.model.form.values)
        setAddDetail(false)
        setIsEditMode(false)
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        // setRequest()
        // setIsShowConfirm(false)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleCheckAll = (value, checked) => {
    let newArr = []
    const checkedKeys = checked ? tableData.map((item) => item.id) : []
    tableData.map((item) => {
      if (item.assetStatusCode == '0') {
        newArr.push(item.id)
      }
    })
    setCheckedKeys(checkedKeys)
    setCountSelected(newArr.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    if (!rowData.isEnableEdit) {
      return (
        <Cell {...props} style={{ padding: 0 }}>
          <Checkbox inline disabled style={{ marginLeft: -30 }} />
          {props.rowIndex + 1}
        </Cell>
      )
    }

    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  const handleRequestRegisterAsset = () => {
    const request = {
      ids: checkedKeys,
      note: requestRegisterNote,
    }

    handleSaveRequestRegister(request)
  }

  const handleRequestBeforeRegisterAsset = () => {
    // if (checkedKeys.length == 0) {
    if (countSelected == 0) {
      setIsShowModalHelper(true)
    } else {
      setIsShowReqRegisterModal(true)
    }
  }

  const handleSaveRequestRegister = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response = await saveAssetRegisterRequest(projectCode, periodMainSelection, request)

      if (response) {
        notification.open('success', {
          title: PROCESS_SUCCESS_MSG,
        })

        setTableData(response.model.form.values)
        setIsShowReqRegisterModal(false)
        setRequestRegisterNote('')
        setCountSelected(0)
        setCheckedKeys([])
      } else {
        setIsLoading(false)

        notification.open('error', {
          title: DEFAULT_ERR_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 10000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(fileObj.path)
      var fileName = uuidv4()

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(fileObj.path)
      var fileName = uuidv4()

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreviewAssetRegister = async () => {
    startLoading()
    try {
      var file = await downloadAssetRegisterFile(searchProjectCode || projectCode)
      var fileName = uuidv4()

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleGetPeriodMainSelection = async (projectCode, period, pageNum, pageSize) => {
    setIsSearchLoading(true)
    startLoading()
    try {
      const { model } = await getAssetRegister(projectCode, period, pageNum, pageSize)
      setTableData(model?.form?.values || [])
      setTotalSize(model?.form?.totalSize || 0)
      setIsSearch(true)
      if (model.projectInfo) {
        setProjectInfo(model.projectInfo)
      } else {
        setProjectInfo(null)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsSearchLoading(false)
  }

  const handleChangePeriodOption = (value) => {
    setPeriodMainSelection(value)
    handleGetPeriodMainSelection(projectCode, value)
  }

  const handleViewQrCode = async (rowData) => {
    // console.log('row data => ',rowData)

    setIsLoading(true)
    startLoading()
    try {
      setFileName(rowData.assetCode)

      var file = await downloadDurableArticlesFile(rowData.assetQrCodePathFile)
      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))

      setQrCodeDataRow(url)
      setIsShowQrCodeModal(true)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadQrcode = () => {
    // qrCodeDataRow
    const link = document.createElement('a')
    link.href = qrCodeDataRow
    link.setAttribute('download', fileName || uuidv4())
    document.body.appendChild(link)
    link.click()
  }

  const onDelete = (rowData) => {
    console.log('onDelete ', rowData)
    let datas = cloneDeep(assetOtherAttach)

    let newArr = []
    let deleteArr = deleteAttachFiles

    if (datas.length > 0) {
      datas.map((item) => {
        if (rowData.id != item.id) {
          newArr.push(item)
        } else {
          deleteArr.push(item)
        }
      })
      setAssetOtherAttach(newArr)
      setDeleteAttachFiles(deleteArr)
    } else {
      setAssetOtherAttach(datas)
    }
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    handleGetPeriodMainSelection(searchProjectCode, searchPeriod, 1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    handleGetPeriodMainSelection(searchProjectCode, searchPeriod, dataKey, displayLength)
  }

  const Speaker = ({ content, ...props }) => {
    return (
      <Popover {...props}>
        <div style={{ maxWidth: 400 }}>
          <p style={{ fontSize: '1rem' }}>{content}</p>
        </div>
      </Popover>
    )
  }

  const CustomComponent = ({ preMsg, msg }) => (
    <Whisper trigger="click" placement="top" speaker={<Speaker content={msg} />}>
      <span style={{ fontSize: '0.9rem', color: '#2da888', cursor: 'pointer' }}>
        {' '}
        <u>... เพิ่มเติม</u>
      </span>
    </Whisper>
  )
  return (
    <>
      {(isLoading || isSearchLoading) && <OverlayLoader />}
      <Panel
        collapsible
        defaultExpanded
        bordered
        style={{ marginTop: schema.isSupplyOfficer ? -10 : 20 }}
      >
        {schema.periodOption && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Controller
                name={schema.periodOption.name}
                control={control}
                defaultValue={periodOptionValue}
                render={(props) => {
                  return (
                    <SelectPicker
                      style={{ border: '2px solid #2da888', borderRadius: 8 }}
                      searchable={false}
                      data={schema.periodOption.options}
                      value={props.value}
                      block
                      placeholder="เลือก"
                      onChange={(value) => {
                        props.onChange(value)
                        setPeriodOptionValue(value)
                        handleChangePeriodOption(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right', color: '#2da888' }}>
              {`งวดที่ ${periodMainSelection || ''}`}
            </Col>
          </Row>
        )}

        {schema.isSupplyOfficer && (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                <ControlLabel>{schema.projectCode.label}</ControlLabel>
                <Controller
                  name={schema.projectCode.name}
                  control={control}
                  defaultValue={searchProjectCode}
                  render={(props) => {
                    return (
                      <Input
                        value={props.value}
                        placeholder={schema.projectCode.label}
                        onChange={(value) => {
                          props.onChange(value)
                          setSearchProjectCode(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
                <ControlLabel>{schema.period.label}</ControlLabel>
                <Controller
                  name={schema.period.name}
                  control={control}
                  defaultValue={searchPeriod}
                  render={(props) => {
                    return (
                      <NumberFormat
                        className="rs-input"
                        disabled={schema.period.disabled}
                        thousandSeparator={false}
                        value={props.value}
                        placeholder={schema.period.label}
                        onValueChange={(value) => {
                          props.onChange(value.floatValue)
                          setSearchPeriod(value.floatValue)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10, marginLeft: 5 }}>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="search" className="bt-gost-icon-radius" />}
                onClick={() => {
                  setDisplayLength(defaultDisplay)
                  setPage(defaultPage)

                  handleGetPeriodMainSelection(
                    searchProjectCode,
                    searchPeriod,
                    defaultPage,
                    defaultDisplay
                  )
                }}
                size="sm"
              >
                ค้นหา
              </IconButton>
            </Row>

            {projectInfo && (
              <Row style={{ marginTop: 10, marginLeft: 5 }}>
                <hr />
                <MiniProjectInfo schema={projectInfo} />
              </Row>
            )}

            {/* {messageInfo && (
              <Row style={{ marginTop: 10, marginLeft: 5 }}>
                <div>
                  <Message
                    type="info"
                    description={<span dangerouslySetInnerHTML={{ __html: messageInfo }} />}
                  />
                </div>
              </Row>
            )} */}
          </>
        )}
        {!isSearchLoading && (
          <div className="table-all-articles">
            <Table
              wordWrap
              //autoHeight
              autoHeight={tableData?.length > 10 ? false : true}
              height={tableData?.length > 10 ? 800 : undefined}
              headerHeight={fs <= 16 ? 40 : 80}
              data={tableData}
              style={{ marginTop: '20px' }}
              loading={loading || isSearchLoading}
            >
              {!isViewMode && (
                <Column width={95} align="center">
                  <HeaderCell style={{ padding: 0 }}>
                    <div style={{ lineHeight: '40px' }}>
                      <Controller
                        name="chkRow"
                        control={control}
                        render={(props) => {
                          if (isEditMode) {
                            return 'ลำดับ'
                          }
                          return (
                            <Checkbox
                              inline
                              checked={props.value}
                              indeterminate={indeterminate}
                              onChange={(e, checked) => {
                                props.onChange(checked)
                                handleCheckAll(null, checked)
                              }}
                              style={{ marginLeft: -10 }}
                            >
                              <b>ลำดับ</b>
                            </Checkbox>
                          )
                        }}
                      />
                    </div>
                  </HeaderCell>

                  <CheckCell
                    dataKey="id"
                    checkedKeys={checkedKeys}
                    onChange={(value, checked) => {
                      handleCheck(value, checked)
                    }}
                  />
                </Column>
              )}

              {isViewMode && (
                <Column width={80} align="center">
                  <HeaderCell>ลำดับ</HeaderCell>

                  <Cell>
                    {(_, index) => {
                      if (pagination) {
                        return index + 1 + (page * displayLength - displayLength)
                      } else {
                        return index + 1
                      }
                    }}
                  </Cell>
                </Column>
              )}

              {schema.isSupplyOfficer && (
                <Column width={140}>
                  <HeaderCell>รหัสโครงการ</HeaderCell>
                  <Cell dataKey="projectCode" />
                </Column>
              )}

              <Column width={180}>
                <HeaderCell>เลขที่ใบสำคัญ</HeaderCell>
                <Cell dataKey="registerDocNo" />
              </Column>

              <Column width={140}>
                <HeaderCell>เลขที่ใบเสร็จ</HeaderCell>
                <Cell dataKey="assetBillNo" />
              </Column>

              <Column width={200} align="center">
                <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
                {/* <Cell dataKey="assetCode" style={{ fontWeight: 'bold' }} /> */}
                <Cell>
                  {(rowData) => {
                    return <b style={{ color: '#2da888' }}>{rowData.assetCode}</b>
                  }}
                </Cell>
              </Column>

              <Column width={250} minWidth={250} flexGrow={1}>
                <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
                <Cell dataKey="assetName" />
              </Column>

              <Column width={200}>
                <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
                <Cell dataKey="assetType" />
              </Column>

              <Column width={180} align="right">
                <HeaderCell>ราคา/หน่วย (รวม VAT)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData.totalPrice || 0)
                  }}
                </Cell>
              </Column>

              <Column width={200} align="center">
                <HeaderCell>สถานะครุภัณฑ์</HeaderCell>
                {/* <Cell dataKey="assetStatus" /> */}
                <Cell>
                  {(rowData) => {
                    return (
                      <TagCell
                        dataKey="assetStatus"
                        rowData={rowData}
                        bgColor={rowData.assetStatusBgColor}
                        color={rowData.assetStatusColor}
                      />
                    )
                    //return <p style={{ color: _color }}>{rowData.assetStatus}</p>
                  }}
                </Cell>
              </Column>

              <Column width={220}>
                <HeaderCell align="center">ความเห็นเจ้าหน้าที่พัสดุ</HeaderCell>
                {/* <Cell dataKey="assetStatus" /> */}
                <Cell>
                  {(rowData) => {
                    var showStr = rowData.approvedComment
                    var isOver = false

                    if (rowData.approvedComment?.length > 26) {
                      showStr = rowData.approvedComment?.substring(20, 0)
                      isOver = true
                    }

                    return (
                      <div>
                        {showStr}
                        {isOver && (
                          <CustomComponent preMsg={showStr} msg={rowData.approvedComment} />
                        )}
                      </div>
                    )
                  }}
                </Cell>
              </Column>

              {isViewMode && (
                <Column width={70} align="right">
                  <HeaderCell></HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return (
                        <Button
                          color="blue"
                          appearance="link"
                          onClick={() => onViewHistory(rowData.id)}
                        >
                          ประวัติ
                        </Button>
                      )
                    }}
                  </Cell>
                </Column>
              )}

              <Column width={185} align="center" fixed="right">
                <HeaderCell>จัดการรายการ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (rowData.isRowTotal) {
                      return ''
                    }

                    if (rowData.isEnableEdit && !isViewMode) {
                      return (
                        <>
                          <IconButton
                            appearance="ghost"
                            className="rs-btn-ghost-edit"
                            icon={
                              <Icon icon="plus-square-o" className="bt-gost-icon-radius-edit" />
                            }
                            size="sm"
                            onClick={(e) => {
                              handleClickDetailModal(rowData)
                            }}
                          >
                            เพิ่มรายละเอียด
                          </IconButton>
                        </>
                      )
                    } else {
                      return (
                        <>
                          <IconButton
                            appearance="ghost"
                            // className="rs-btn-ghost-edit"
                            icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                            onClick={() => {
                              handleClickDetailModal(rowData)
                            }}
                            size="sm"
                          >
                            แสดง
                          </IconButton>
                          <IconButton
                            disabled={!rowData.assetQrCodePathFile}
                            appearance="ghost"
                            className="rs-btn-ghost-info"
                            icon={<Icon icon="qrcode" className="bt-gost-icon-radius-info" />}
                            onClick={(e) => {
                              // console.log('rowData ', rowData)
                              // setIsShowQrCodeModal(true)
                              // setQrCodeDataRow(rowData)
                              handleViewQrCode(rowData)
                            }}
                            size="sm"
                            style={{ marginLeft: 3 }}
                          >
                            QR
                          </IconButton>
                        </>
                      )
                    }
                  }}
                </Cell>
              </Column>
            </Table>
            {pagination && (
              <TablePagination
                lengthMenu={lengthMenu || defaultLengthMenu}
                activePage={page || defaultPage}
                renderLengthMenu={(lengthMenu) => {
                  return (
                    <>
                      {lengthMenu}
                      {`รายการ/หน้า`}
                    </>
                  )
                }}
                renderTotal={(total) => {
                  return <>{` ทั้งหมด ${total} รายการ`}</>
                }}
                displayLength={displayLength || 5}
                total={totalSize}
                onChangePage={handleChangePage}
                onChangeLength={handleChangeLength}
              />
            )}
          </div>
        )}
      </Panel>
      <Row style={{ marginTop: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {(projectCode || (isSearch && searchProjectCode?.length == 8)) && (
            <Button
              loading={isLoading}
              appearance="subtle"
              style={{ marginRight: 10 }}
              onClick={() => {
                onPreviewAssetRegister()
              }}
            >
              <Icon icon="print" size="lg" /> พิมพ์รายงาน พน. 3
            </Button>
          )}

          {!isViewMode && !schema.isSupplyOfficer && (
            <Button
              loading={isLoading}
              color="blue"
              appearance="primary"
              onClick={(e) => {
                handleRequestBeforeRegisterAsset()
              }}
            >
              {`ขอขึ้นทะเบียน (${countSelected} รายการ)`}
            </Button>
          )}
        </Col>
      </Row>

      {/* Modal ขอขึ้นทะเบียน */}
      <Modal
        show={isShowReqRegisterModal}
        size="lg"
        onHide={(e) => {
          setIsShowReqRegisterModal(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{formSchema.requestRegister.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          <ErrorMessage error={errors[formSchema.requestRegister.note.name]} />

          <Controller
            name={formSchema.requestRegister.note.name}
            control={control}
            defaultValue={formSchema.requestRegister.note.value || ''}
            rules={isValidators(formSchema.requestRegister.note.validators)}
            render={(props) => {
              return (
                <>
                  <Input
                    componentClass="textarea"
                    rows={4}
                    placeholder={'ระบุ' + formSchema.requestRegister.note.label}
                    value={props.value}
                    maxLength={getMaxLengthData(formSchema.requestRegister.note.validators).value}
                    onChange={(value, e) => {
                      props.onChange(value)
                      setRequestRegisterNote(value)
                    }}
                    disabled={formSchema.requestRegister.note.disabled}
                  />
                  <ShowLimitLength
                    textLength={props.value?.length || 0}
                    maxLength={getMaxLengthData(formSchema.requestRegister.note.validators)?.value}
                  />
                </>
              )
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="send-o" className="bt-gost-icon-radius" />}
            onClick={(e) => {
              handleRequestRegisterAsset()
            }}
          >
            {formSchema.requestRegister.buttonText.requestRegister || 'ส่งขอขึ้นทะเบียน'}
          </IconButton>
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
            onClick={(e) => {
              setIsShowReqRegisterModal(false)
            }}
          >
            {formSchema.requestRegister.buttonText.cancel || 'ยกเลิก'}
          </IconButton>
        </Modal.Footer>
      </Modal>

      {/* Modal เพิ่มรายละเอียด */}
      <Modal
        size="lg"
        show={isAddDetail}
        onHide={(e) => {
          setAddDetail(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{isEditMode ? 'เพิ่ม/แก้ไขรายละเอียด' : 'ดูรายละเอียด'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '1000px !important' }}>
          <Panel>
            {assetRegisSchema && (
              <>
                {assetRegisSchema.assetName && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetName.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetName.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetName.name]} />
                      <Input
                        placeholder={assetRegisSchema.assetName.label}
                        defaultValue={assetRegisSchema.assetName.value}
                        name={assetRegisSchema.assetName.name}
                        inputRef={register(isValidators(assetRegisSchema.assetName.validators))}
                        disabled={!isEditMode}
                      />
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.price && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={
                          !isEditMode &&
                          classNames(
                            'style-text-lable',
                            isRequired(assetRegisSchema.price.validators) && 'required'
                          )
                        }
                      >
                        {assetRegisSchema.price.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.price.name]} />
                      <InputGroup>
                        <Input
                          placeholder={assetRegisSchema.price.label}
                          defaultValue={assetRegisSchema.price.value || 0}
                          name={assetRegisSchema.price.name}
                          inputRef={register(
                            !isEditMode && isValidators(assetRegisSchema.price.validators)
                          )}
                          disabled={true}
                        />
                        <InputGroup.Addon>บาท</InputGroup.Addon>
                      </InputGroup>
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetSerialNo && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetSerialNo.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetSerialNo.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetSerialNo.name]} />
                      <Input
                        placeholder={assetRegisSchema.assetSerialNo.label}
                        defaultValue={assetRegisSchema.assetSerialNo.value}
                        name={assetRegisSchema.assetSerialNo.name}
                        inputRef={register(isValidators(assetRegisSchema.assetSerialNo.validators))}
                        disabled={!isEditMode}
                      />
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetModel && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetModel.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetModel.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetModel.name]} />
                      <Input
                        placeholder={assetRegisSchema.assetModel.label}
                        defaultValue={assetRegisSchema.assetModel.value}
                        name={assetRegisSchema.assetModel.name}
                        inputRef={register(isValidators(assetRegisSchema.assetModel.validators))}
                        disabled={!isEditMode}
                      />
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetBrand && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetBrand.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetBrand.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetBrand.name]} />
                      <Input
                        placeholder={assetRegisSchema.assetBrand.label}
                        defaultValue={assetRegisSchema.assetBrand.value}
                        name={assetRegisSchema.assetBrand.name}
                        inputRef={register(isValidators(assetRegisSchema.assetBrand.validators))}
                        disabled={!isEditMode}
                      />
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetType && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={
                          myDataRow.assetStatusCode == '4' &&
                          classNames(
                            'style-text-lable',
                            isRequired(assetRegisSchema.assetType.validators) && 'required'
                          )
                        }
                      >
                        {assetRegisSchema.assetType.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetType.name]} />
                      <Controller
                        name={assetRegisSchema.assetType.name}
                        control={control}
                        defaultValue={assetRegisSchema.assetType.value || ''}
                        rules={isValidators(assetRegisSchema.assetType.validators)}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={assetRegisSchema.assetType.options}
                              value={props.value}
                              style={{ width: '100%' }}
                              placeholder="เลือก"
                              onChange={(value) => {
                                props.onChange(value)
                              }}
                              disabled={!isEditMode || myDataRow.assetStatusCode != '4'}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                )}

                {/* เลขที่ใบเสร็จ */}
                {assetRegisSchema.assetBillNo && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={
                          myDataRow.assetStatusCode == '4' &&
                          classNames(
                            'style-text-lable',
                            isRequired(assetRegisSchema.assetBillNo.validators) && 'required'
                          )
                        }
                      >
                        {assetRegisSchema.assetBillNo.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetBillNo.name]} />
                      <Input
                        placeholder={assetRegisSchema.assetBillNo.label}
                        defaultValue={assetRegisSchema.assetBillNo.value}
                        name={assetRegisSchema.assetBillNo.name}
                        inputRef={register(
                          myDataRow.assetStatusCode == '4' &&
                            isValidators(assetRegisSchema.assetBillNo.validators)
                        )}
                        disabled={!isEditMode || myDataRow.assetStatusCode != '4'}
                      />
                    </Col>
                  </Row>
                )}

                {/* วันที่ในใบเสร็จ */}
                {assetRegisSchema.assetBillDate && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={
                          myDataRow.assetStatusCode == '4' &&
                          classNames(
                            'style-text-lable',
                            isRequired(assetRegisSchema.assetBillDate.validators) && 'required'
                          )
                        }
                      >
                        {assetRegisSchema.assetBillDate.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetBillDate.name]} />
                      <Controller
                        key={assetRegisSchema.assetBillDate.name}
                        name={assetRegisSchema.assetBillDate.name}
                        control={control}
                        defaultValue={
                          assetRegisSchema.assetBillDate.value
                            ? moment(
                                assetRegisSchema.assetBillDate.value,
                                DD_MM_YYYY_SLASH
                              ).toDate()
                            : null //moment().startOf('day').toDate()
                        }
                        rules={
                          myDataRow.assetStatusCode == '4' &&
                          isValidators(assetRegisSchema.assetBillDate.validators)
                        }
                        // inputRef={register(
                        //   myDataRow.assetStatusCode == '4' && isValidators(assetRegisSchema.assetBillNo.validators)
                        // )}
                        render={(props) => {
                          return (
                            <DatePickerCustom
                              {...props}
                              disabled={!isEditMode || myDataRow.assetStatusCode != '4'}
                            />
                            // <DatePicker
                            //   format={DATE_PICKER_FORMAT}
                            //   locale={LOCAL_DAY_TH}
                            //   block
                            //   oneTap
                            //   value={props.value}
                            //   onChange={(value) => {
                            //     props.onChange(value)
                            //     // onChangeReportDate(value)
                            //   }}
                            //   disabled={!isEditMode}
                            // />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                )}

                {/* วันที่ตรวจรับพัสดุ */}
                {assetRegisSchema.assetReceiveDate && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetReceiveDate.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetReceiveDate.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.assetReceiveDate.name]} />
                      <Controller
                        key={assetRegisSchema.assetReceiveDate.name}
                        name={assetRegisSchema.assetReceiveDate.name}
                        control={control}
                        defaultValue={
                          assetRegisSchema.assetReceiveDate.value
                            ? moment(
                                assetRegisSchema.assetReceiveDate.value,
                                DD_MM_YYYY_SLASH
                              ).toDate()
                            : null //moment().startOf('day').toDate()
                        }
                        rules={isValidators(assetRegisSchema.assetReceiveDate.validators)}
                        render={(props) => {
                          return <DatePickerCustom {...props} disabled={!isEditMode} />
                        }}
                      />
                    </Col>
                  </Row>
                )}

                {/* เอกสารตรวจนับ */}
                {assetRegisSchema.assetReceiveFile && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      {/* แนบใบเสร็จครุภัณฑ์ */}
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetReceiveFile.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetReceiveFile.label + assetReceivePathFile?.length}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      {isEditMode && assetReceivePathFile?.length == 0 ? (
                        <>
                          <ErrorMessage error={errors[assetRegisSchema.assetReceiveFile.name]} />
                          <Controller
                            name={assetRegisSchema.assetReceiveFile.name}
                            control={control}
                            // defaultValue={undefined}
                            rules={isValidators(assetRegisSchema.assetReceiveFile.validators)}
                            render={(props) => {
                              return (
                                <Uploader
                                  accept={
                                    assetRegisSchema.assetReceiveFile.fileType ||
                                    '.jpg, .jpeg, .png, .pdf'
                                  }
                                  draggable
                                  autoUpload={false}
                                  multiple={false}
                                  // removable={false}
                                  // disabled={myDataRow.assetStatusCode != '4'}
                                  fileList={props.value || []}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                    } else {
                                      // props.onChange(fileList)
                                      let files = []
                                      files.push(fileList[fileList.length - 1])
                                      //props.onChange(files)

                                      if (
                                        files[0].blobFile.size >
                                        (assetRegisSchema?.assetBillPathFile?.fileSize ||
                                          defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            assetRegisSchema.assetReceiveFile.fileSize ||
                                            defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(files[0].blobFile.type)) {
                                        props.onChange(files)
                                      } else {
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              assetRegisSchema.assetReceiveFile.fileType ||
                                            '.jpg, .jpeg, .png, .pdf',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                >
                                  <div>
                                    <Icon size="2x" icon="upload2" />
                                    <small className="uploder__text"></small>
                                    {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                      assetRegisSchema.assetReceiveFile.fileType ||
                                      '.jpg, .jpeg, .png, .pdf'
                                    } , ขนาดไฟล์ไม่เกิน ${
                                      assetRegisSchema.assetReceiveFile.fileSize ||
                                      defaultMaxFileSize
                                    } MB`}
                                  </div>
                                </Uploader>
                              )
                            }}
                          />
                        </>
                      ) : (
                        <div>
                          {assetReceivePathFile?.length > 0 && (
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                onClick={(e) => {
                                  const found = assetReceivePathFile.find((_, index) => index == 0)
                                  onPreview(found)
                                }}
                              />
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                onClick={(e) => {
                                  const found = assetReceivePathFile.find((_, index) => index == 0)
                                  onDownload(found)
                                }}
                              />
                              {isEditMode && (
                                <TooltipButton
                                  isStart={false}
                                  icon="trash-o"
                                  tooltip={`ลบ`}
                                  // disabled={isEditMode}
                                  onClick={() => {
                                    setAssetReceivePathFile([])
                                    setStaDeleteAssetReceiveFile(true)
                                  }}
                                  iconStyle={{ backgroundColor: '#fb8a81' }}
                                />
                              )}
                            </ButtonGroup>
                          )}

                          {/* <IncomeRecordFileTable
                            data={assetBillPathFile}
                            onPreview={onPreview}
                            onDownload={onDownload}
                          /> */}
                        </div>
                      )}

                      {/* {assetBillPathFile?.length > 0 && (
                        
                      )} */}
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.status && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.status.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.status.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      <ErrorMessage error={errors[assetRegisSchema.status.name]} />
                      <Input
                        placeholder={assetRegisSchema.status.label}
                        defaultValue={assetRegisSchema.status.value}
                        name={assetRegisSchema.status.name}
                        inputRef={register(isValidators(assetRegisSchema.status.validators))}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetBillPathFile && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      {/* แนบใบเสร็จครุภัณฑ์ */}
                      <ControlLabel
                        className={
                          myDataRow.assetStatusCode == '4' &&
                          classNames(
                            'style-text-lable',
                            isRequired(assetRegisSchema.assetBillPathFile.validators) && 'required'
                          )
                        }
                      >
                        {assetRegisSchema.assetBillPathFile.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      {isEditMode && assetBillPathFile?.length == 0 ? (
                        <>
                          <ErrorMessage error={errors[assetRegisSchema.assetBillPathFile.name]} />
                          <Controller
                            name={assetRegisSchema.assetBillPathFile.name}
                            control={control}
                            // defaultValue={undefined}
                            rules={isValidators(assetRegisSchema.assetBillPathFile.validators)}
                            render={(props) => {
                              return (
                                <Uploader
                                  accept={
                                    assetRegisSchema.assetBillPathFile.fileType ||
                                    '.jpg, .jpeg, .png, .pdf'
                                  }
                                  draggable
                                  autoUpload={false}
                                  multiple={false}
                                  // removable={false}
                                  disabled={myDataRow.assetStatusCode != '4'}
                                  fileList={props.value || []}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                    } else {
                                      // props.onChange(fileList)
                                      let files = []
                                      files.push(fileList[fileList.length - 1])
                                      //props.onChange(files)

                                      if (
                                        files[0].blobFile.size >
                                        (assetRegisSchema?.assetBillPathFile?.fileSize ||
                                          defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            assetRegisSchema.assetBillPathFile.fileSize ||
                                            defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(files[0].blobFile.type)) {
                                        props.onChange(files)
                                      } else {
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              assetRegisSchema.assetBillPathFile.fileType ||
                                            '.jpg, .jpeg, .png, .pdf',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                >
                                  <div>
                                    <Icon size="2x" icon="upload2" />
                                    <small className="uploder__text"></small>
                                    {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                      assetRegisSchema.assetBillPathFile.fileType ||
                                      '.jpg, .jpeg, .png, .pdf'
                                    } , ขนาดไฟล์ไม่เกิน ${
                                      assetRegisSchema.assetBillPathFile.fileSize ||
                                      defaultMaxFileSize
                                    } MB`}
                                  </div>
                                </Uploader>
                              )
                            }}
                          />
                        </>
                      ) : (
                        <div>
                          {assetBillPathFile?.length > 0 && (
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                onClick={(e) => {
                                  const found = assetBillPathFile.find((_, index) => index == 0)
                                  onPreview(found)
                                }}
                              />
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                onClick={(e) => {
                                  const found = assetBillPathFile.find((_, index) => index == 0)
                                  onDownload(found)
                                }}
                              />
                              {isEditMode && myDataRow.assetStatusCode == '4' && (
                                <TooltipButton
                                  isStart={false}
                                  icon="trash-o"
                                  tooltip={`ลบ`}
                                  // disabled={isEditMode}
                                  onClick={() => {
                                    setAssetBillPathFile([])
                                    setStaDeleteAssetBillPathFile(true)
                                  }}
                                  iconStyle={{ backgroundColor: '#fb8a81' }}
                                />
                              )}
                            </ButtonGroup>
                          )}

                          {/* <IncomeRecordFileTable
                            data={assetBillPathFile}
                            onPreview={onPreview}
                            onDownload={onDownload}
                          /> */}
                        </div>
                      )}

                      {/* {assetBillPathFile?.length > 0 && (
                        
                      )} */}
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetPicturePathFile && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      {/* แนบรูปภาพครุภัณฑ์ */}
                      <ControlLabel
                        className={classNames(
                          'style-text-lable',
                          isRequired(assetRegisSchema.assetPicturePathFile.validators) && 'required'
                        )}
                      >
                        {assetRegisSchema.assetPicturePathFile.label}
                      </ControlLabel>
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      {isEditMode && assetPicturePathFile?.length == 0 ? (
                        <>
                          <ErrorMessage
                            error={errors[assetRegisSchema.assetPicturePathFile.name]}
                          />

                          <Controller
                            name={assetRegisSchema.assetPicturePathFile.name}
                            control={control}
                            // defaultValue={undefined}
                            rules={isValidators(assetRegisSchema.assetPicturePathFile.validators)}
                            render={(props) => {
                              return (
                                <Uploader
                                  accept={
                                    assetRegisSchema.assetPicturePathFile.fileType ||
                                    '.jpg, .jpeg, .png, .pdf'
                                  }
                                  draggable
                                  autoUpload={false}
                                  multiple={false}
                                  fileList={props.value || []}
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                    } else {
                                      // props.onChange(fileList)
                                      let files = []
                                      files.push(fileList[fileList.length - 1])
                                      //props.onChange(files)

                                      if (
                                        files[0].blobFile.size >
                                        (assetRegisSchema?.assetPicturePathFile?.fileSize ||
                                          defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            assetRegisSchema.assetPicturePathFile.fileSize ||
                                            defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(files[0].blobFile.type)) {
                                        props.onChange(files)
                                      } else {
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              assetRegisSchema.assetPicturePathFile.fileType ||
                                            '.jpg, .jpeg, .png, .pdf',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                >
                                  <div>
                                    <Icon size="2x" icon="upload2" />
                                    <small className="uploder__text"></small>
                                    {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                      assetRegisSchema.assetPicturePathFile.fileType ||
                                      '.jpg, .jpeg, .png, .pdf'
                                    } , ขนาดไฟล์ไม่เกิน ${
                                      assetRegisSchema.assetPicturePathFile.fileSize ||
                                      defaultMaxFileSize
                                    } MB`}
                                  </div>
                                </Uploader>
                              )
                            }}
                          />
                        </>
                      ) : (
                        <div>
                          {assetPicturePathFile?.length > 0 && (
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                onClick={(e) => {
                                  const found = assetPicturePathFile.find((_, index) => index == 0)
                                  onPreview(found)
                                }}
                              />
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                onClick={(e) => {
                                  const found = assetPicturePathFile.find((_, index) => index == 0)
                                  onDownload(found)
                                }}
                              />
                              {isEditMode && (
                                <TooltipButton
                                  isStart={false}
                                  icon="trash-o"
                                  tooltip={`ลบ`}
                                  // disabled={isEditMode}
                                  onClick={() => {
                                    setAssetPicturePathFile([])
                                    setStaDeleteAssetPicturePathFile(true)
                                  }}
                                  iconStyle={{ backgroundColor: '#fb8a81' }}
                                />
                              )}
                            </ButtonGroup>
                          )}

                          {/* <IncomeRecordFileTable
                            data={assetPicturePathFile}
                            onPreview={onPreview}
                            onDownload={onDownload}
                          /> */}
                        </div>
                      )}
                    </Col>
                  </Row>
                )}

                {assetRegisSchema.assetOtherAttach && (
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      {assetRegisSchema.assetOtherAttach.label}
                    </Col>
                    <Col lg={18} md={18} sm={24} xs={24}>
                      {isEditMode && (
                        <>
                          <ErrorMessage error={errors[assetRegisSchema.assetOtherAttach.name]} />

                          <Controller
                            name={assetRegisSchema.assetOtherAttach.name}
                            control={control}
                            defaultValue={undefined}
                            render={(props) => {
                              return (
                                <Uploader
                                  accept={
                                    assetRegisSchema.assetOtherAttach.fileType ||
                                    '.jpg, .jpeg, .png, .pdf'
                                  }
                                  draggable
                                  autoUpload={false}
                                  fileList={props.value || []}
                                  multiple
                                  onChange={(fileList) => {
                                    if (isEmpty(fileList)) {
                                      props.onChange(undefined)
                                    } else {
                                      let file = fileList[fileList.length - 1]

                                      if (
                                        file.blobFile.size >
                                        (assetRegisSchema?.assetOtherAttach?.fileSize ||
                                          defaultMaxFileSize) *
                                          1024 *
                                          1024
                                      ) {
                                        notification.open('error', {
                                          title: `ขนาดไฟล์เกิน ${
                                            assetRegisSchema.assetOtherAttach.fileSize ||
                                            defaultMaxFileSize
                                          } MB`,
                                          duration: 5000,
                                        })
                                        return
                                      }

                                      if (isImageOrPdf(file.blobFile.type)) {
                                        props.onChange(fileList)
                                        // setFileTypeError(false)
                                      } else {
                                        // setFileTypeError(true)
                                        notification.open('error', {
                                          title:
                                            'ชนิดที่รองรับ ' +
                                              assetRegisSchema.assetOtherAttach.fileType ||
                                            '.jpg, .jpeg, .png, .pdf',
                                          duration: 5000,
                                        })
                                      }
                                    }
                                  }}
                                >
                                  <div>
                                    <Icon size="2x" icon="upload2" />
                                    <small className="uploder__text"></small>
                                    {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                                      assetRegisSchema.assetOtherAttach.fileType ||
                                      '.jpg, .jpeg, .png, .pdf'
                                    } , ขนาดไฟล์ไม่เกิน ${
                                      assetRegisSchema.assetOtherAttach.fileSize ||
                                      defaultMaxFileSize
                                    } MB`}
                                  </div>
                                </Uploader>
                              )
                            }}
                          />
                        </>
                      )}

                      {assetOtherAttach?.length > 0 && (
                        <div>
                          <IncomeRecordFileTable
                            data={assetOtherAttach}
                            onPreview={onPreview}
                            onDownload={onDownload}
                            onDelete={onDelete}
                            deleteable={isEditMode}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                )}
              </>
            )}
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          {isEditMode && <SaveButton onClick={handleSubmit(onSubmit)} children="บันทึก" />}
          <CancelButton
            onClick={(e) => {
              setAddDetail(false)
              setIsEditMode(false)
            }}
            children={isEditMode ? 'ยกเลิก' : 'ปิด'}
          />
        </Modal.Footer>
      </Modal>

      {/* Modal Qr Code */}
      <Modal
        show={isShowQrCodeModal}
        size="xs"
        onHide={(e) => {
          setIsShowQrCodeModal(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered>
            {/* <Row style={{ textAlign: 'center', marginTop: 10, marginBottom: 15 }}>
              <b>{qrCodeDataRow.assetCode || '- ไม่พบระหัสสินค้า -'}</b>
            </Row> */}
            <div style={{ height: 'auto', margin: '0 auto', width: '100%', textAlign: 'center' }}>
              <img
                src={qrCodeDataRow}
                alt="Contact Us"
                style={{ width: '70%', minWidth: 250, height: 300 }}
                className="contact-img "
              />
            </div>
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <hr />
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon icon="download" className="bt-gost-icon-radius-info" />}
                onClick={() => {
                  handleDownloadQrcode()
                }}
                size="sm"
              >
                Download
              </IconButton>
            </div>
          </Panel>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      {/* )} */}

      <AlertWidget
        title={globalMsgUtil.WARN_SELECTED_ITEM_TITLE}
        show={isShowModalHelper}
        detail={globalMsgUtil.WARN_SELECTED_ITEM_DETAIL}
        onClose={() => {
          setIsShowModalHelper(false)
        }}
      />
    </>
  )
}
